/**
 * Literal palettes for callers that need the colour itself as data (for example a season tier
 * colour sent to the backend), not a themable reference. They mirror the NBX catalog and a unit
 * test fails when they drift from it; styling code uses the `var(--nbx-…)` references instead.
 */
export const rentsodyBlue = {
  50: '#e7e8ec',
  100: '#ced1d8',
  200: '#b5bac4',
  300: '#838b9c',
  400: '#6b7489',
  500: '#525d75',
  600: '#394661',
  700: '#212f4e',
  800: '#08183a',
  900: '#071634',
  950: '#06132e',
} as const;
